import { render, staticRenderFns } from "./AgencyBanner.vue?vue&type=template&id=54c74968&scoped=true"
import script from "./AgencyBanner.vue?vue&type=script&lang=js"
export * from "./AgencyBanner.vue?vue&type=script&lang=js"
import style0 from "./AgencyBanner.vue?vue&type=style&index=0&id=54c74968&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c74968",
  null
  
)

export default component.exports